import React from 'react'
import { Parallax } from "react-parallax";
import tokenomicsImage from "../../../assets/images/1768512.webp";
import blinkstarimg from "../../../assets/images/main-slider-star-3.png";

const CharacterRaritySettings = () => {
  return (
    <Parallax
                  bgImage={tokenomicsImage}
                  strength={300}
                  bgImageStyle={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                >
            <section className="list02 authorm5 cid-uOFOieFpab cha-rar-set"
            style={{
              minHeight: "70vh",
              display: "flex",
              alignItems: "start",
              color: "#fff",
            }}
            >
                <img src={blinkstarimg} className='hero-star-2' alt="" />
                <img src={blinkstarimg} className='hero-star-2 star2' alt="" />
                 <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-11" data-aos="fade-up">
                            <h2 className="mbr-section-title mbr-fonts-style align-center display-2">Character Rarity Settings</h2>
                            <p className="mbr-text mbr-fonts-style align-center display-4">
                                The rarity of each accessory is determined by the distance between Bearth Planet and other celestial bodies —<br /> the farther the planet, the rarer the accessory.
                            </p>
                        </div>
                        <div className="col-12 col-lg-11" data-aos="zoom-in" data-aos-offset="500" data-aos-duration="500">
                            <img src={require('../../../assets/images/setting-bg.png')} alt="Character Rarity Settings" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
    </Parallax>
  )
}

export default CharacterRaritySettings